import {useMemo} from "react";
import {bffApi} from "./bffApi";
import {metricUuid, newMetricEvent} from "./metrics";

export function useInteractionAnalytics() {
    const [track] = bffApi.endpoints.trackInteraction.useMutation();
    return useMemo(() => ({
        emailCopied(subjectId: string) {
            void track({
                ...newMetricEvent(),
                action: "email_copied",
                subjectId: metricUuid(subjectId),
            });
        },
        emailHandoffRequested(subjectId: string, mailtoBodyIncluded: boolean) {
            void track({
                ...newMetricEvent(),
                action: "email_handoff_requested",
                subjectId: metricUuid(subjectId),
                mailtoBodyIncluded,
            });
        },
        fillingShareOpened(subjectId: string) {
            void track({
                ...newMetricEvent(),
                action: "filling_share_opened",
                subjectId: metricUuid(subjectId),
            });
        },
        fillingSharingUpdated(subjectId: string, addedCount: number, removedCount: number, failedCount: number) {
            const outcome = failedCount === 0 ? "full" : addedCount + removedCount > 0 ? "partial" : "failed";
            void track({
                ...newMetricEvent(),
                action: "filling_sharing_updated",
                subjectId: metricUuid(subjectId),
                addedCount,
                removedCount,
                failedCount,
                outcome,
            });
        },
        fillingSharingFailed(subjectId: string, failedCount: number) {
            void track({
                ...newMetricEvent(),
                action: "filling_sharing_updated",
                subjectId: metricUuid(subjectId),
                addedCount: 0,
                removedCount: 0,
                failedCount,
                outcome: "failed",
            });
        },
    }), [track]);
}
